import { useState } from "react";
import { Row, Col, Button, Card, ListGroup, Badge } from "react-bootstrap";
import AddEditClientMedications from "./EditSections/AddEditClientMedications";
import toDateOnly from "../../utilities/toDateOnly";
import toTimeOnly from "../../utilities/toTimeOnly";

const Medication = ({ data }) => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [ProcessData, setdata] = useState(data.emarMedicationHeader);
  const [action, setAction] = useState("add");
  const [DatatoEdit, setDateToEdit] = useState(null);

  function handleAddClick() {
    setAction("add");
    setShowAdd(true);
    setShowEdit(false);
  }

  const editEventClicked = (data2) => {
    setDateToEdit(data2);
    setAction("edit");
    setShowAdd(false);
    setShowEdit(true);
  };

  // Helper for badge color
  const statusBadgeVariant = (status) => {
    if (!status || status.toLowerCase() === "active") return "info"; // blue
    // gray for stopped/discontinued/other
    return "secondary";
  };

  return (
    <>
      <Row className="justify-content-center">
        <Col md={8}>
          <Card>
            <Card.Header>
              <span style={{ float: "right" }}>
                <Button variant="outline-primary" size="sm" onClick={handleAddClick}>
                  + New Medication
                </Button>
              </span>
              <h5>Medications</h5>
            </Card.Header>
            <ListGroup variant="flush">
              {ProcessData && ProcessData.length === 0 && (
                <ListGroup.Item>
                  <i>No medications recorded.</i>
                </ListGroup.Item>
              )}
              {ProcessData &&
                ProcessData.map((row, idx) => (
                  <ListGroup.Item key={row.id || idx} className="mb-3">
                    <Card>
                      <Card.Body>
                        <Row>
                          <Col xs={12} md={8}>
                            <Card.Title>
                              {row.emarMedicationName}{" "}
                              <Badge bg={statusBadgeVariant(row.status)} className="ms-2">
                                {row.status || "Unknown"}
                              </Badge>
                            </Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                              Dose: {row.emarMedicationDosage}
                              <br />
                              Schedule: {row.emarDailySchedule}
                            </Card.Subtitle>
                            <Card.Text>
                              <strong>Instructions:</strong>{" "}
                              {row.emarMedicationUsageInstructions || <i>None supplied</i>}
                            </Card.Text>
                            <Card.Text style={{ fontSize: "0.95em", color: "#6c757d" }}>
                              <i>
                                Created on {toDateOnly(row.dateCreated)} {toTimeOnly(row.dateCreated)}
                              </i>
                            </Card.Text>
                          </Col>
                          <Col xs={12} md={4} className="d-flex align-items-center justify-content-end">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => editEventClicked(row)}
                            >
                              View/Edit
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          </Card>
        </Col>
      </Row>

      {showAdd && (
        <AddEditClientMedications
          show={showAdd}
          action={action}
          CustomerId={data.customerId}
          setShowAddEdit={setShowAdd}
          data={ProcessData}
          setdata={setdata}
        />
      )}
      {showEdit && (
        <AddEditClientMedications
          show={showEdit}
          action={action}
          CustomerId={data.customerId}
          setShowAddEdit={setShowEdit}
          data={DatatoEdit}
          fulldata={ProcessData}
          setdata={setdata}
        />
      )}
    </>
  );
};

export default Medication;
